export enum Mutations {
    NOTIFY = 'NOTIFY',

    ADD_USER = 'ADD_USER',
    LOGIN_USER = 'LOGIN_USER',
    LOGGOUT_USER = 'LOGGOUT_USER',
    USER_LOGGED = 'USER_LOGGED',
    SAVE_NEW_KEY = 'SAVE_NEW_KEY',

    ADD_CONFIGURED_FILTERS = 'ADD_CONFIGURED_FILTERS',
    ADD_FEEDBACKS = 'ADD_FEEDBACKS',
    TOOGLE_LOADING_FEEDBACKS = 'TOOGLE_LOADING_FEEDBACKS',
    ADD_CURRENT_FEEDBACK_TYPE = 'ADD_CURRENT_FEEDBACK_TYPE',
    ADD_PAGINATION_FEEDBACKS = 'ADD_PAGINATION_FEEDBACKS',
    CLEAR_FEEDBACKS = 'CLEAR_FEEDBACKS',
    CLEAR_PAGINATION_FEEDBACKS = 'CLEAR_PAGINATION_FEEDBACKS',

    TOOGLE_LOADING = 'TOOGLE_LOADING',
    TOOGLE_ERROR = 'TOOGLE_ERROR',
}
